import { getGitType } from '@/api/widget';

export default {
  namespaced: true,
  state: {
    gitTypes: null
  },
  mutations: {
    SET_GIT_TYPES(state, data) {
      state.gitTypes = data;
    },
    ClEAR_GIT_TYPES(state) {
      state.gitTypes = null;
    }
  },
  actions: {
    async getGitTypes({ state, commit }, force) {
      if (!force && state.gitTypes) {
        return state.gitTypes;
      }
      const data = await getGitType() || [];
      commit('SET_GIT_TYPES', data);
      return data;
    }
  },
  getters: {}
};
